
import create from '../utils/create';

export default create({
  render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: _vm.b() }, [_c('span', { class: _vm.b('portion'), style: _vm.portionStyle }, [_c('span', { directives: [{ name: "show", rawName: "v-show", value: _vm.showPivot, expression: "showPivot" }], class: _vm.b('pivot'), style: _vm.pivotStyle }, [_vm._v(_vm._s(_vm.pivotText))])])]);
  },

  name: 'progress',

  props: {
    inactive: Boolean,
    pivotColor: String,
    percentage: {
      type: Number,
      required: true,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    showPivot: {
      type: Boolean,
      default: true
    },
    pivotText: {
      type: String,
      default: function _default() {
        return this.percentage + '%';
      }
    },
    color: {
      type: String,
      default: '#38f'
    },
    textColor: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    componentColor: function componentColor() {
      return this.inactive ? '#cacaca' : this.color;
    },
    pivotStyle: function pivotStyle() {
      return {
        color: this.textColor,
        background: this.pivotColor || this.componentColor
      };
    },
    portionStyle: function portionStyle() {
      return {
        width: this.percentage + '%',
        background: this.componentColor
      };
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.1.4@vant/es/progress/index.js
// module id = null
// module chunks = 